import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
// Import analytics eagerly so its module-load ?utm_* snapshot runs BEFORE any
// client-side navigation strips the marketing params from the URL.
import "@/lib/analytics";

import Splash from "@/pages/Splash";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import NewScene from "@/pages/NewScene";
import SceneDetail from "@/pages/SceneDetail";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Profile from "@/pages/Profile";
import LeoChat from "@/pages/LeoChat";
import AdminStripe from "@/pages/AdminStripe";
import QuoteGate from "@/pages/QuoteGate";
import CRM from "@/pages/CRM";
import CRMContact from "@/pages/CRMContact";
import AuditionDetail from "@/pages/AuditionDetail";
import CareerPath from "@/pages/CareerPath";
import UkAgentTemplate from "@/pages/UkAgentTemplate";
import CareerPathPreview from "@/pages/CareerPathPreview";
import ResetPassword from "@/pages/ResetPassword";
import GoalDetail from "@/pages/GoalDetail";
import OperationalTasks from "@/pages/OperationalTasks";
import GentleReminders from "@/pages/GentleReminders";
import Radar from "@/pages/Radar";
import MastermindNext from "@/pages/MastermindNext";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google Auth callback — session_id in URL fragment
  if (location.hash?.includes("session_id=")) {
    return (
      <Layout>
        <AuthCallback />
      </Layout>
    );
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Splash />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/leo" element={<ProtectedRoute><LeoChat /></ProtectedRoute>} />
        <Route path="/leo/:id" element={<ProtectedRoute><LeoChat /></ProtectedRoute>} />
        <Route path="/scenes/new" element={<ProtectedRoute><NewScene /></ProtectedRoute>} />
        <Route path="/scenes/:id" element={<ProtectedRoute><SceneDetail /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/admin/stripe" element={<ProtectedRoute><AdminStripe /></ProtectedRoute>} />
        <Route path="/enter" element={<ProtectedRoute><QuoteGate /></ProtectedRoute>} />
        <Route path="/crm" element={<ProtectedRoute><CRM /></ProtectedRoute>} />
        <Route path="/crm/auditions/:id" element={<ProtectedRoute><AuditionDetail /></ProtectedRoute>} />
        <Route path="/crm/:id" element={<ProtectedRoute><CRMContact /></ProtectedRoute>} />
        <Route path="/career" element={<ProtectedRoute><CareerPath /></ProtectedRoute>} />
        <Route path="/career/templates/uk-agent" element={<ProtectedRoute><UkAgentTemplate /></ProtectedRoute>} />
        <Route path="/career/preview/:template" element={<ProtectedRoute><CareerPathPreview /></ProtectedRoute>} />
        <Route path="/career/goals/:id" element={<ProtectedRoute><GoalDetail /></ProtectedRoute>} />
        <Route path="/career/mastermind-next" element={<ProtectedRoute><MastermindNext /></ProtectedRoute>} />
        <Route path="/ops/tasks" element={<ProtectedRoute><OperationalTasks /></ProtectedRoute>} />
        <Route path="/reminders" element={<ProtectedRoute><GentleReminders /></ProtectedRoute>} />
        <Route path="/radar" element={<ProtectedRoute><Radar /></ProtectedRoute>} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
